/** 每页条数 = 5 列 × 2 行，对齐 vuefront 同行首页 */
export const TRADEMARK_PAGE_SIZE = 10

export const GRID_COLUMNS = 5

export const SORT_TABS = [
  { key: 'default', label: '综合排序', sort: 'default' },
  { key: 'new', label: '新品', sort: 'new' },
  { key: 'hot', label: '人气', sort: 'hot' }
]

export const FILTER_OPTIONS = {
  categories: [
    { label: '全部类别', value: '' },
    { label: '01类 化工原料', value: '1' },
    { label: '25类 服装鞋帽', value: '25' },
    { label: '29类 食品', value: '29' },
    { label: '30类 方便食品', value: '30' },
    { label: '35类 广告销售', value: '35' },
    { label: '43类 餐饮住宿', value: '43' }
  ],
  statuses: [
    { label: '全部状态', value: '' },
    { label: '在售', value: 'on_sale' },
    { label: '新品', value: 'new' },
    { label: '热门', value: 'hot' }
  ],
  prices: [
    { label: '全部价格', value: '', min: 0, max: 0 },
    { label: '5000以下', value: '0-5000', min: 0, max: 5000 },
    { label: '5000-1万', value: '5000-10000', min: 5000, max: 10000 },
    { label: '1万-3万', value: '10000-30000', min: 10000, max: 30000 },
    { label: '3万以上', value: '30000+', min: 30000, max: 0 }
  ],
  sorts: [
    { label: '默认排序', value: 'default' },
    { label: '价格升序', value: 'price_asc' },
    { label: '价格降序', value: 'price_desc' }
  ]
}

export const CARD_COLORS = [
  '#e74c3c', '#f39c12', '#27ae60', '#3498db', '#9b59b6',
  '#1abc9c', '#e91e63', '#ff5722', '#3f51b5', '#009688'
]
